import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Box, Divider, Grid, Icon, IconButton, Modal, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { globalTranslate } from "../../../../shared/utils";

interface Props {
	open: boolean;
	rowSelect: any;
	onClose: () => void;
	name?: string;
}

export const ModalDetailValue = ({ open, rowSelect, onClose, name }: Props) => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (open) {
			setIsLoading(true);
			const timeout = setTimeout(() => setIsLoading(false), 500);
			return () => clearTimeout(timeout);
		}
	}, [open]);

	const InfoItem = ({ icon, label, value }: { icon: string; label: string; value?: string | number }) => (
		<Grid item xs={12} md={6}>
			<Stack direction="row" spacing={2} alignItems="center">
				<Avatar sx={{ bgcolor: "#f0f0f0", width: 32, height: 32 }}>
					<Icon fontSize="small" sx={{ color: "primary.main" }}>
						{icon}
					</Icon>
				</Avatar>
				<Box>
					<Typography variant="caption" color="text.secondary">
						{label}
					</Typography>
					<Typography variant="subtitle2" color="text.secondary">
						{value ?? "-"}
					</Typography>
				</Box>
			</Stack>
		</Grid>
	);

	const InfoItemFull = ({ icon, label, value }: { icon: string; label: string; value?: string | number }) => (
		<Grid item xs={12}>
			<Stack direction="row" spacing={2} alignItems="center">
				<Avatar sx={{ bgcolor: "#f0f0f0", width: 32, height: 32 }}>
					<Icon fontSize="small" sx={{ color: "primary.main" }}>
						{icon}
					</Icon>
				</Avatar>
				<Box>
					<Typography variant="caption" color="text.secondary">
						{label}
					</Typography>
					<Typography variant="subtitle2" color="text.secondary">
						{value ?? "-"}
					</Typography>
				</Box>
			</Stack>
		</Grid>
	);

	return (
		<Modal open={open} onClose={onClose}>
			<Box
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					bgcolor: "background.paper",
					boxShadow: 24,
					p: 4,
					width: "90%",
					maxWidth: 700,
					maxHeight: "90vh",
					overflowY: "auto",
					borderRadius: 2,
				}}
			>
				<LoadingComp isopen={isLoading} />

				<Grid container direction="column" spacing={2}>
					<Grid item container justifyContent="space-between" alignItems="center">
						<Typography variant="h4" sx={{ color: "primary.main", fontWeight: 300 }}>
							Informações do lançamento do sinistro
						</Typography>
						<IconButton onClick={onClose} size="small">
							<CloseIcon />
						</IconButton>
					</Grid>

					<Divider sx={{ my: 1 }} />

					<Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
						Informações do Sinistro
					</Typography>
					<Grid item container spacing={2}>
						{!!name && <InfoItem icon="person" label="Inquilino" value={name} />}
						{!!rowSelect?.createdAt && (
							<InfoItem
								icon="calendar_month"
								label="Data de Criação"
								value={format(new Date(rowSelect.createdAt), "dd/MM/yyyy", { locale: ptBR })}
							/>
						)}
						{!!rowSelect?.reason?.length && <InfoItem icon="description" label="Motivo do Sinistro" value={rowSelect.reason} />}
					</Grid>

					<Divider sx={{ my: 2 }} />

					<Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
						Detalhes do Lançamento
					</Typography>
					<Grid item container spacing={2}>
						{!!rowSelect?.typeId?.length && (
							<InfoItem icon="edit_document" label="Débito" value={`${globalTranslate(rowSelect.typeId)} ${rowSelect.reference ?? ""}`} />
						)}

						{!!rowSelect?.value?.length && (
							<InfoItem
								icon="attach_money"
								label="Valor"
								value={Number(rowSelect.value).toLocaleString("pt-br", {
									style: "currency",
									currency: "BRL",
								})}
							/>
						)}
					</Grid>
					<Divider sx={{ my: 2 }} />

					<Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
						Resultado da Análise
					</Typography>
					<Grid item container spacing={2}>
						{!!rowSelect?.status?.length && <InfoItem icon="refresh" label="Status" value={globalTranslate(rowSelect.status)} />}
						{!!rowSelect?.valueApproved && Number(rowSelect.valueApproved) > 0 && (
							<InfoItem
								icon="attach_money"
								label="Valor Aprovado"
								value={Number(rowSelect.valueApproved).toLocaleString("pt-br", {
									style: "currency",
									currency: "BRL",
								})}
							/>
						)}
						{!!rowSelect?.reasonApproved?.length && (
							<InfoItemFull icon="check_circle" label="Observações da Aprovação" value={rowSelect.reasonApproved} />
						)}
						{!!rowSelect?.reasonRefused?.length && <InfoItemFull icon="cancel" label="Motivo de Recusa" value={rowSelect.reasonRefused} />}
						{!!rowSelect?.reasonContested?.length && <InfoItemFull icon="question_answer" label="Contestação" value={rowSelect.reasonContested} />}
						{!!rowSelect?.reasonCancel?.length && <InfoItemFull icon="block" label="Motivo de Cancelamento" value={rowSelect.reasonCancel} />}
					</Grid>
				</Grid>
			</Box>
		</Modal>
	);
};
